export enum CLOSURE_DATE_PLATE_BACKGROUNDS {
  default = "#D0F2FF",
  empty = "#FFE0EF",
  active = "#AFE9FF",
}
